






























import {Vue, Component, Prop} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import {getStoreSettings, HELP_EMAIL, nil, ORDER_STATUS, stripeKeys, testStripeKeys} from '@/common';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {getZonedBookingDate} from '@/utils';

@Component({
    components: {},
})
export default class CustomerOrderCard extends Mixins(GlobalAlertMixin) {
    @Prop({default: () => null})
    public order!: any;

    public tooLateToCancel = false;
    public settings: any = {};
    public mounted() {
        this.fetchStoreSettings();
    }
    public async fetchStoreSettings() {
        this.settings = await getStoreSettings(this.$FeathersVuex.Setting);
    }
    public get orderDate() {
        return `Order Placed On ${DateTime.fromISO(this.order.createdAt).toFormat('DDDD')}`;
    }
    public get cancelling() {
        return this.order.status === ORDER_STATUS.CANCELLING;
    }
    public get cancelled() {
        return this.order.status === ORDER_STATUS.CANCELLED;
    }
    public get placing() {
        return this.order.status === ORDER_STATUS.PLACING;
    }
    public get items(): any[] {
        if (nil(this.order)) {
            return [];
        }
        const i: any[] = [];
        if (!nil(this.order.bookingModels)) {
            i.push({header: 'Bookings'});
            for (const booking of this.order.bookingModels) {
                const today = DateTime.local();
                const date = DateTime.fromISO(booking.date);
                const zonedDate = getZonedBookingDate(booking);
                const earliestCancelCutoff = date.plus({days: this.settings.cancellationThreshold || 3});
                if (today > earliestCancelCutoff) {
                    this.tooLateToCancel = true;
                }

                const {purchasableModel} = booking;
                const {categoryModel, tierModel} = purchasableModel;

                const time = zonedDate.toFormat('h a');
                const guests = `${booking.guests} guest${booking.guests > 1 ? 's' : ''}`;
                const subtitle = `${zonedDate.toFormat('DDDD')} at ${time} for ${guests}`;
                let vendorLine = 'You requested';
                if (nil(booking.requestedVendor)) {
                    vendorLine += ' any pro';
                } else {
                    const {firstName} = booking.requestedVendorModel;
                    vendorLine += ` ${firstName}`;
                }
                vendorLine += ` for ${booking.duration} hour${booking.duration > 1 ? 's' : ''} of service`;
                i.push({
                    title: `${categoryModel.name} ${tierModel.name} ${purchasableModel.name}`,
                    vendorLine,
                    subtitle,
                });
                i.push({divider: true});
            }
        }
        i.pop();
        return i;
    }
    public async proceedToStripe(orderModel) {
        if (nil(orderModel.stripeSessionId)) {
            this.showAlert(`There was a problem placing your order, please contact ${HELP_EMAIL} if this persists.`);
        } else {
            const settings = await getStoreSettings(this.$FeathersVuex.Setting);
            const stripe = (window as any).Stripe(settings.testMode ? testStripeKeys.public : stripeKeys.public);
            const checkout = await stripe.redirectToCheckout({sessionId: orderModel.stripeSessionId});
        }
    }
    public get orderIsFulfilled() {
        if (nil(this.order)) {
            return false;
        }
        return this.order.status === ORDER_STATUS.FULFILLED;
    }
}
